import { computePricing } from "./pricing";

// Readiness score out of 100 grading completeness + strength of an evaluation.
export function computeScore(plan) {
  const swot = plan.swot || {};
  const quads = ["strengths", "weaknesses", "opportunities", "threats"];
  let swotPts = 0;
  quads.forEach((q) => {
    const n = swot[q]?.length || 0;
    swotPts += n >= 2 ? 10 : n === 1 ? 5 : 0; // 40 max
  });

  const compCount = plan.competitors?.length || 0;
  const compPts = compCount >= 3 ? 20 : compCount >= 1 ? 10 : 0; // 20 max

  const p = plan.pricing || {};
  const priced = Number(p.cogs) > 0 && Number(p.volume) > 0 && Number(p.margin) > 0;
  const pricePts = priced ? 15 : 0; // 15 max

  const tasks = ["phase1", "phase2", "phase3"].flatMap((ph) => plan.action_plan?.[ph] || []);
  const totalTasks = tasks.length;
  const doneTasks = tasks.filter((t) => t.done).length;
  const presencePts = Math.round((Math.min(totalTasks, 8) / 8) * 15); // 15
  const donePts = totalTasks ? Math.round((doneTasks / totalTasks) * 10) : 0; // 10
  const actionPts = presencePts + donePts; // 25 max

  const score = Math.min(100, swotPts + compPts + pricePts + actionPts);

  let grade, tone;
  if (score >= 80) { grade = "Investor-ready"; tone = "emerald"; }
  else if (score >= 60) { grade = "Solid"; tone = "sky"; }
  else if (score >= 40) { grade = "Getting there"; tone = "amber"; }
  else { grade = "Early draft"; tone = "rose"; }

  return {
    score,
    grade,
    tone,
    breakdown: [
      { label: "SWOT depth", points: swotPts, max: 40 },
      { label: "Competitor research", points: compPts, max: 20 },
      { label: "Pricing modelled", points: pricePts, max: 15 },
      { label: "Action plan", points: actionPts, max: 25 },
    ],
  };
}

export const SCORE_TONE = {
  emerald: { text: "text-emerald-400", ring: "text-emerald-400", badge: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  sky: { text: "text-sky-400", ring: "text-sky-400", badge: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  amber: { text: "text-amber-400", ring: "text-amber-400", badge: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  rose: { text: "text-rose-400", ring: "text-rose-400", badge: "bg-rose-500/15 text-rose-300 border-rose-500/30" },
};
